import { pick } from 'lodash'

import { IAdvancedAddress } from '../../../../1stlog-ui/src/types'

export const relevantAddressProps = [
  'reference',
  'name1',
  'name2',
  'name3',
  'street',
  'streetNumber',
  'streetNumberAddition',
  'zip',
  'city',
  'country',
  'showContact',
  'prename',
  'surname',
  'phone1',
  'mail',
  'eori',
  'ustid',
]

export default relevantAddressProps

export function getRelevantAddressProps(
  address: IAdvancedAddress,
): IAdvancedAddress {
  return pick(address, relevantAddressProps)
}
